const PREFIX = "my-trips-login_form-switcher_click:";
const FIND_BY_BOOKING_REFERENCE = "find-by-booking-reference";
const LOGIN = "login";
export const FORM_SWITCHER = {
  FIND_BY_BOOKING_REFERENCE: `${PREFIX}${FIND_BY_BOOKING_REFERENCE}`,
  LOGIN: `${PREFIX}${LOGIN}`
};